import { ToastContainer } from 'react-toastify';

import './App.css';
import 'react-toastify/dist/ReactToastify.min.css';
import MyRoutesTest from './routes/MyRoutesTest';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import AuthNavigationHandler from './components/AuthNavigationHandler';
import SWRProvider from './providers/SWRProvider';
import AuthLoadingScreen from './components/AuthLoadingScreen';
import { useAuthSync } from './hooks/useAuthSync';

function AppContent() {
  const { isLoading, isInitialized } = useAuth();

  // Initialize auth synchronization across tabs
  useAuthSync();

  // Show loading screen while Firebase auth is initializing
  if (isLoading || !isInitialized) {
    return <AuthLoadingScreen />;
  }

  return (
    <div className='App'>
      <AuthNavigationHandler />
      <MyRoutesTest />
      <ToastContainer
        position='bottom-right'
        autoClose={2000}
        // hideProgressBar
        newestOnTop={true}
        closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

function App() {
  return (
    <SWRProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </SWRProvider>
  );
}
export default App;
